import { Icon, type IconName } from "../ui/Icon";
import { Sheet } from "../ui/Sheet";

export interface SheetAction {
  icon: IconName;
  label: string;
  onSelect: () => void;
  /** What cannot be undone, drawn red. */
  danger?: boolean;
}

/** A row's actions as a sheet (`.k-act`): icon and label rows, a tap runs the action and closes the sheet. */
export function ActionsSheet({ open, onClose, title, actions }: { open: boolean; onClose: () => void; title: string; actions: ReadonlyArray<SheetAction> }) {
  return (
    <Sheet open={open} onClose={onClose} title={title}>
      <ul className="k-act">
        {actions.map((a) => (
          <li key={a.label}>
            <button
              type="button"
              className={a.danger ? "k-bad" : undefined}
              onClick={() => {
                onClose();
                a.onSelect();
              }}
            >
              <Icon name={a.icon} />
              {a.label}
            </button>
          </li>
        ))}
      </ul>
    </Sheet>
  );
}
